import { connect } from 'react-redux';
import DuplicateModal from '../duplicate/DuplicateModal';
import { duplicateHeatPump } from '../../redux/heat_pump/heat_pump_actions';

const mapStateToProps = state => ({
  isDuplicating: state.hotWaterSystem.heatPump.isDuplicating,
  errorMessage: state.hotWaterSystem.heatPump.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateHeatPump(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/heat_pump/HeatPumpDuplicateModal.js